// utils/encrypt.js (React)
// ★ นำเข้าเฉพาะโมดูล AES (เดิม import crypto-js ทั้งชุด = โหลด tripledes/blowfish/
//   sha512/ripemd160 ฯลฯ ที่ไม่ได้ใช้ ~5% ของ bundle) — ผลลัพธ์เข้ารหัสเหมือนเดิม 100%
import AES from "crypto-js/aes";

const _K = process.env.REACT_APP_ENCRYPTION_KEY;

export function encryptData(data) {
  if (!_K) return "";
  return AES.encrypt(JSON.stringify(data), _K).toString();
}
